import React from "react";
import PropTypes from "prop-types";
import {
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  FormGroup,
  ModalFooter,
} from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import { AvForm, AvField } from "availity-reactstrap-validation";

const CampaignStatusModal = props => {
  const {
    isOpen,
    toggle,
    data,
    addCampaignStatus,
    updateCampaignStatusProfile,
    editData,
  } = props;

  const [colorPicker, setColorPicker] = React.useState();

  React.useEffect(() => {
    if (editData !== null && isOpen) {
      setColorPicker(editData.color);
    } else {
      setColorPicker("#000000");
    }
  }, [isOpen]);

  const handleValidOrderSubmit = (e, errors, params) => {
    if (errors?.length === 0) {
      let status = {
        ...params,
        color: colorPicker,
      };

      if (editData !== null) {
        updateCampaignStatusProfile(editData.id, status, data);
        toggle();
      } else {
        addCampaignStatus(status, data);
        toggle();
      }
    }
  };

  return (
    <Modal isOpen={isOpen} autoFocus={true} centered={true} toggle={toggle}>
      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          {editData !== null ? "Edit" : "Add"} campaign status
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={handleValidOrderSubmit}>
        <ModalBody>
          <Row form>
            <Col className="col-12">
              <FormGroup className="mb-3">
                <Label>Format name</Label>
                <AvField
                  name="name"
                  type="text"
                  placeholder="Format name..."
                  errorMessage="This value is required."
                  value={editData?.name || ""}
                  validate={{
                    required: { value: true },
                  }}
                />
              </FormGroup>
              <Row>
                <Col sm={10}>
                  <FormGroup className="mb-3">
                    <Label>Description</Label>
                    <AvField
                      name="description"
                      type="text"
                      placeholder="Description..."
                      errorMessage="This value is required."
                      value={editData?.description || ""}
                      validate={{
                        required: { value: false },
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col sm={2}>
                  <div className="mb-3">
                    <FormGroup className="mb-3">
                      <Label>Color</Label>
                      <input
                        className="form-control form-control-color mw-100 w-100"
                        type="color"
                        value={colorPicker}
                        onChange={e => setColorPicker(e.target.value)}
                        id="example-color-input"
                      />
                    </FormGroup>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {props.permissions?.["change_campaignstatusmodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

CampaignStatusModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  data: PropTypes.any,
  addCampaignStatus: PropTypes.func,
  updateCampaignStatusProfile: PropTypes.func,
  editData: PropTypes.any,
  permissions: PropTypes.any,
};

export default CampaignStatusModal;
